var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 13.5 12.6 1.7C12.1.7 11.1.2 10 .2S7.9.7 7.4 1.7L.8 13.5c-.5.9-.5 2.1 0 3 .5.9 1.5 1.5 2.6 1.5h13.2c1.1 0 2-.6 2.6-1.5.6-.9.5-2 0-3Zm-1.7 2c-.1.1-.3.5-.9.5H3.4c-.5 0-.8-.3-.9-.5-.1-.2-.3-.5 0-1L9.1 2.6c.3-.5.7-.5.9-.5.2 0 .6 0 .9.5l6.6 11.9c.2.5 0 .9 0 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })));
};

export default SvgWarning;